import { Helmet } from 'react-helmet';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Menu } from 'antd';
import { Link } from 'react-router-dom';
import { PageProps } from '@/types/PageProps';
import DefaultRouteTabs from '@/components/_common/DefaultRouteTabs';
import { useState } from 'react';
import { useDisclosure } from '@/hooks';
import AccountReceivableList from '@/components/Registry/BillToReceive/AccountReceivableList';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { AccountReceivableReverseMultipleInstallmentsModal } from '@/components/Registry/BillToReceive/AccountReceivableReverseMultipleInstallmentsModal';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';
import { DefaultMoreVertDropdown } from '@/components/_common';

function ReleaseBillToReceivePage({ route }: PageProps) {
  const intl = useIntl();

  const [modalReverseMultipleOpened, modalReverseMultipleAction] =
    useDisclosure();
  const [btnType, setBtnType] = useState<'reverse' | 'delete'>();

  return (
    <>
      <DefaultRouteTabs
        route={route.parent}
        persistSearchParams={false}
        permissions={route.permissions}
        extra={
          <SpaceForButton>
            <Link to="/app/financial/billToReceiver/releaseBillToReceiver/create">
              <Button
                disabled={
                  !hasPermissions([
                    Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_ADD,
                  ])
                }
                type="primary"
                block
              >
                <FormattedMessage id="releaseBillToReceiver.searchBar.create" />
              </Button>
            </Link>

            <DefaultMoreVertDropdown>
              <Menu>
                <Menu.Item
                  key="reverseInstallments"
                  onClick={() => {
                    setBtnType('reverse');
                    modalReverseMultipleAction.open();
                  }}
                  disabled={
                    !hasPermissions([
                      Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_REFUND_INSTALLMENT,
                    ])
                  }
                >
                  Estornar parcelas
                </Menu.Item>

                <Menu.Item
                  key="deleteInstallments"
                  onClick={() => {
                    setBtnType('delete');
                    modalReverseMultipleAction.open();
                  }}
                  disabled={
                    !hasPermissions([
                      Authorities.FINANCIAL_ACCOUNT_RECEIVABLE_DELETE_INSTALLMENTS,
                    ])
                  }
                >
                  Excluir parcelas
                </Menu.Item>
              </Menu>
            </DefaultMoreVertDropdown>
          </SpaceForButton>
        }
      >
        <Helmet title={intl.formatMessage({ id: route.name })} />

        <AccountReceivableList />
      </DefaultRouteTabs>

      <AccountReceivableReverseMultipleInstallmentsModal
        btnType={btnType}
        open={modalReverseMultipleOpened}
        onCancel={modalReverseMultipleAction.close}
      />
    </>
  );
}

export default ReleaseBillToReceivePage;
